<template>
  <div class="row bg-white max-height-vertical max-height-auto box-overflow">
    <full-span-slide v-bind:active="active">
      <h1 v-html="title"></h1>

      <p v-for="paragraph in markedParagraphs" v-bind:key="paragraph.index" v-html="paragraph"></p>

      <div v-if="content.text_box">
        <textarea class="form-text-area p" ref="textarea" v-bind:placeholder="content.text_box" v-on:keyup="keyCallback"></textarea>
        <p class="transition-1" v-bind:class="showCaptionClass">Press <span class="bold">ENTER</span> to submit</p>
      </div>

    </full-span-slide>
  </div>
</template>

<script>
  import full_span_slide from '../../components/organisms/full_span_slide'
  import marked from 'marked'
  import 'nodelist-foreach-polyfill'; // ie11
  import {is_active} from '../../utils/is_active'

  export default {
    props: ['title', 'content', 'active'],
    data () {
      return {
        showCaptionClass: 'invisible'
      }
    },
    methods: {
      keyCallback(e) {

        if (this.$refs.textarea.value.length) {
          // display text
          this.showCaptionClass = ''
        } else {
          // hide text
          this.showCaptionClass = 'invisible'
        }

        if (e.keyCode === 13) {
          setTimeout(() => {
            // window resize trigger
            // window.dispatchEvent(new Event('resize'));
            this.$store.commit('change_page', 1)
          }, 250)
        }

      }
    },
    computed: {
      markedParagraphs () {
        if(this.content.paragraphs) {
          return this.content.paragraphs.map((paragraph) => {
            return marked(paragraph)
          })
        }
      }
    },
    components: {
      'full-span-slide': full_span_slide
    },
    watch: {
      active () {
        is_active(this, false)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// full_page.vue?09fe0980